/** Correos en minúsculas y sin espacios: es la forma en que se guardan y se comparan en las reglas. */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

// Validación pragmática (no RFC completa): algo@dominio.tld, sin espacios.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isValidEmail = (email: string): boolean => EMAIL.test(normalizeEmail(email));

/**
 * Convierte el texto que pega el admin (separado por comas, saltos de línea o punto y coma)
 * en una lista única de correos normalizados, y reporta los inválidos.
 */
export function parseEmailList(input: string): { valid: string[]; invalid: string[] } {
  const valid = new Set<string>();
  const invalid: string[] = [];
  for (const raw of input.split(/[\s,;]+/)) {
    if (!raw) continue;
    const email = normalizeEmail(raw);
    if (isValidEmail(email)) valid.add(email);
    else invalid.push(raw.trim());
  }
  return { valid: [...valid], invalid };
}
